import React from 'react';

export const getTsAndCsText = (
  tsAndCsLink?: string,
  organiserName?: string,
) => {
  return (
    <>
      I accept the CrowdClip®{' '}
      <a href="https://my.crowdclip.com/terms" target="_blank" rel="noreferrer">
        T&C
      </a>
      {tsAndCsLink && (
        <>
          {' '}
          and {organiserName || "event organiser's"}{' '}
          <a href={tsAndCsLink} target="_blank" rel="noreferrer">
            T&C
          </a>
        </>
      )}
    </>
  );
};
